<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!resellerProduct">
      <span class="loader"></span>
    </span>
    <div v-if="resellerProduct" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <reseller-product-view-global :resellerProduct="resellerProduct" />
        </tab-pane>

        <tab-pane title="gallery" id="2">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GALLERY") }}
          </span>
          <reseller-product-view-gallery :resellerProduct="resellerProduct" />
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <resellerProduct-view-logs :resellerProduct="resellerProduct" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ResellerProductViewGlobal from "../partials/ResellerProductViewGlobal.vue";
import ResellerProductViewLogs from "../partials/ResellerProductViewLogs.vue";
import ResellerProductViewGallery from "../partials/ResellerProductViewGallery.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    ResellerProductViewGlobal,
    ResellerProductViewGallery,
    ResellerProductViewLogs,
  },

  mixins: [requestErrorMixin],

  props: {
    resellerProductId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      resellerProduct: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch(
          "resellerProducts/get",
          this.resellerProductId
        );
        this.resellerProduct =
          this.$store.getters["resellerProducts/resellerProduct"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
